/**
 * أحداث Meta Pixel.
 *
 * الكود الأساسي في index.html يطلق PageView مرة واحدة عند تحميل الصفحة. وهذا
 * موقع أحادي الصفحة يغيّر المسار بلا إعادة تحميل، فبقية الأحداث تُطلق من هنا
 * عند الوصول الفعلي لكل مرحلة.
 *
 * ⚠️ لا تنادِ fbq('init') من هنا إطلاقاً. المكتبة تحتفظ بقائمة بالبكسلات
 * المسجّلة، وإعادة النداء بنفس المعرّف تضيف تسجيلاً ثانياً فيُرسَل كل حدث تالٍ
 * مرة عن كل تسجيل — طلبان يظهران أربعة. التسجيل الوحيد في index.html.
 *
 * لرفع جودة المطابقة استعمل «المطابقة المتقدّمة التلقائية» من إعدادات البكسل
 * في Events Manager: تقرأها Meta من حقول النموذج بنفسها بلا سطر كود.
 *
 * لا تُرسل أي بيانات شخصية: الاسم والجوال والعنوان تبقى عندنا وحدنا.
 */

/** معرّف المنتج في كتالوج الإعلانات — يجب أن يطابق ما تضعه في Facebook Catalog */
export const CONTENT_ID = 'matrxs-steamer';

/** الشيكل بالرمز الدولي: Meta ترفض رمز ₪ ولا تحتسب قيمة الحدث بدونه */
export const CURRENCY = 'ILS';

export function track(event, params) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq('track', event, params);
}

/** زار صفحة المنتج */
export function trackViewContent(value) {
  track('ViewContent', {
    content_ids: [CONTENT_ID],
    content_type: 'product',
    content_name: 'MATRXS Garment Steamer',
    currency: CURRENCY,
    value,
  });
}

/** فتح صفحة الطلب — أقوى إشارة نيّة شراء قبل الإتمام */
export function trackInitiateCheckout({ value, quantity }) {
  track('InitiateCheckout', {
    content_ids: [CONTENT_ID],
    content_type: 'product',
    currency: CURRENCY,
    value,
    num_items: quantity,
  });
}

/** أكمل الطلب. الدفع عند الاستلام، فلحظة التأكيد هي أقرب ما يقابل الشراء */
export function trackPurchase({ value, quantity }) {
  track('Purchase', {
    content_ids: [CONTENT_ID],
    content_type: 'product',
    currency: CURRENCY,
    value,
    num_items: quantity,
  });
}
